import { useState } from 'react';
import { useQuery } from 'react-query';
import apiClient from '../../apiClient';
import { CalendarPageShiftCreateModal } from './CalendarPageShiftCreateModal';
import { useUrlParameters } from './calendarPageUtils';
import { CompanyBranchDepartmentSelector } from './CalendarCompanyBranchDepartmentSelector';
import { useFilterContext } from './FilterContext';
import { PrimaryButton } from '@tymbe/ui-primitives/*';
import { FavouriteIcon } from '@tymbe/ui-icons';
import Tooltip from 'rc-tooltip';
import Protect from '../../apiClient/Protect';
import { Roles } from '@tymbe/schema/enums';

type CalendarPageHeaderProps = {
  start: string;
  end: string;
}

export const CalendarPageHeader = ({ start, end }: CalendarPageHeaderProps) => {
  const [showCreateShiftModal, setShowCreateShiftModal] = useState(false);
  const [companyIdFromURL, branchofficeIdFromURL, departmentIdFromURL] =
    useUrlParameters();
  const { setShown } = useFilterContext();

  const { data: department } = useQuery(
    ['branchoffice', departmentIdFromURL],
    () => apiClient.service('branchoffice').get(departmentIdFromURL!)
  );

  const getMissingIdStatus = !companyIdFromURL
    ? 'firmu'
    : !branchofficeIdFromURL
    ? 'pobočku'
    : !departmentIdFromURL
    ? 'oddělení'
    : undefined;

  return (
    <div className="flex w-full flex-col items-start justify-between px-10 py-6">
      <div className="flex gap-6 items-center justify-start w-full">
        <h3 className="text-heading-3-xl text-secondary-600 mr-auto">
          Kalendář
        </h3>

        <div className="flex items-center gap-2 justify-center">
          <FavouriteIcon
            name="search"
            className="size-5 cursor-pointer text-secondary-400 lg:hidden"
            onClick={() => setShown((prev) => !prev)}
          />

          <Protect
            auth={[
              Roles.SUPER_ADMIN,
              Roles.TYMBE_ADMIN,
              Roles.TYMBE_COORDINATOR,
              Roles.COMPANY,
              Roles.BRANCHOFFICE_MANAGER,
              Roles.BRANCHOFFICE_SUPERVISOR,
            ]}
            redirect={false}
          >
            <Tooltip
              placement="top"
              trigger="hover"
              overlay={`Nejprve vyberte ${getMissingIdStatus}`}
              overlayClassName={`${department ? '!hidden' : ''}`}
            >
              <div>
                <PrimaryButton
                  type="button"
                  disabled={!department}
                  onClick={() => setShowCreateShiftModal(!showCreateShiftModal)}
                >
                  Vypsat směny
                </PrimaryButton>
              </div>
            </Tooltip>
          </Protect>
        </div>

        {!department ? null : (
          <CalendarPageShiftCreateModal
            showCreateModal={showCreateShiftModal}
            setShowCreateModal={setShowCreateShiftModal}
          />
        )}
      </div>

      <CompanyBranchDepartmentSelector
        className="hidden lg:block w-full"
        showLabels={false}
        start={start}
        end={end}
      />
    </div>
  );
};
